import React from 'react';
import { Box, PaymentRule, Text } from '@common-fe/common-fe';

import PaymentRuleDetails from './PaymentRuleDetails';

interface Props {
  value: PaymentRule;
  ruleNumber: number;
}

const PaymentRuleItem: React.FC<Props> = ({ value, ruleNumber }) => (
  <Box
    key={value.planId}
    pad={{ horizontal: 'm', top: ruleNumber > 1 ? '0' : 'm', bottom: 'm' }}
    data-testid="payment-rule-item"
    height={{ min: '150px' }}
  >
    {ruleNumber > 1 && (
      <Box border={{ side: 'top', color: 'border1', size: '1px' }} pad={{ horizontal: 'spacing4' }} />
    )}
    <Text
      size="large"
      color="textBody"
      margin={{
        bottom: 's',
        top: ruleNumber > 1 ? 's' : '0',
      }}
    >
      {`Payment Rule ${ruleNumber}`}
    </Text>
    <Box direction="row" justify="stretch">
      <PaymentRuleDetails plan={value.planName} isMarginApplied />
      <PaymentRuleDetails maxAmount={value.maxAmount} percentage={value.percentage} />
    </Box>
  </Box>
);

export default PaymentRuleItem;
